import { call, put, takeEvery, takeLatest } from "redux-saga/effects"

// Login Redux States
import {
  GET_AUTH_CUSTOMER,
  GET_AUTH_USER,
  LOGIN_USER,
  LOGOUT_USER,
  SOCIAL_LOGIN,
  UPDATE_AUTH_USER,
  UPDATE_PASSWORD_REQUEST,
} from "./actionTypes"
import {
  apiError,
  getAuthUsersFail,
  getAuthUsersSuccess,
  loginSuccess,
  logoutUserSuccess,
  updateAuthUserFail,
  updateAuthUserSuccess,
} from "./actions"

//Include Both Helper File with needed methods
import { getFirebaseBackend } from "../../../helpers/firebase_helper"
import {
  getAuthUsersResponse,
  getEmployeeResponse,
  postFakeLogin,
  postJwtLogin,
  postJwtLogout,
  postSocialLogin,
  updateAuthUser,
  updateAuthUserPassword,
} from "../../../helpers/fakebackend_helper"
import { setAuthHeader } from "helpers/api_helper"

const fireBaseBackend = getFirebaseBackend()

function* loginUser({ payload: { user, history } }) {
  
  try {
    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const response = yield call(
        fireBaseBackend.loginUser,
        user.userName,
        user.password
      )
      yield put(loginSuccess(response))
    } else if (process.env.REACT_APP_DEFAULTAUTH === "jwt") {
      
      const response = yield call(postJwtLogin, {
        userName: user.userName,
        password: user.password,
      })
      
      localStorage.setItem("authUser", JSON.stringify(response))
      setAuthHeader(response.token)
      history.push(response.user.Designation === "Administrate" ? "/dashboard" : response.user.Designation === "sales" ? "/dashboard" : "/user/dashboard")
      // authUser.user.Designation === "Administrate" ? "/dashboard" : authUser.user.Designation === "sales" ? "/dashboard" :"/user/dashboard"
      
      yield put(loginSuccess(response))
      
    } else if (process.env.REACT_APP_DEFAULTAUTH === "fake") {
      const response = yield call(postFakeLogin, {
        email: user.email,
        password: user.password,
      })
      localStorage.setItem("authUser", JSON.stringify(response))
      
      
      yield put(loginSuccess(response))
    }

    // history.push("/dashboard")
  } catch (error) {
    yield put(apiError(error.message))
  }
}

function* logoutUser({ payload: { history } }) {
  try {
   
    localStorage.removeItem("authUser")

    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const response = yield call(fireBaseBackend.logout)
      yield put(logoutUserSuccess(response))
    }
    if(process.env.REACT_APP_DEFAULTAUTH === "jwt"){
      const response = yield call(postJwtLogout)
      
      yield put(logoutUserSuccess(response))
    }
    history.push("/login")
  } catch (error) {
    yield put(apiError(error))
  }
}

function* socialLogin({ payload: { data, history, type } }) {
  try {
    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const fireBaseBackend = getFirebaseBackend()
      const response = yield call(fireBaseBackend.socialLoginUser, data, type)
      localStorage.setItem("authUser", JSON.stringify(response))

      yield put(loginSuccess(response))
    } else {
      const response = yield call(postSocialLogin, data)
      localStorage.setItem("authUser", JSON.stringify(response))
      
      yield put(loginSuccess(response))
    }
    history.push("/dashboard")
  } catch (error) {
    yield put(apiError(error))
  }
}

function* fetchAuthUsers({payload}) {
  try {
    console.log("fetchAuthUsers payload", payload);
    const response = yield call(getEmployeeResponse, payload)
    yield put(getAuthUsersSuccess(response, payload.url))
  } catch (error) {
    yield put(getAuthUsersFail(error))
  }
}

function* fetchAuthCustomer({payload}) {
  try {
    const response = yield call(getAuthUsersResponse, payload)
    yield put(getAuthUsersSuccess(response, payload.url))
  } catch (error) {
    yield put(getAuthUsersFail(error))
  }
}



function* updateAuthUserfun({payload}) {
  try {
    const response = yield call(updateAuthUser,payload.auth)
    yield put(updateAuthUserSuccess(response))

  } catch (error) {
    console.log("updateAuthUser error:", error); // Debugging line
    yield put(updateAuthUserFail(error))
  }
}

function* updateAuthUserPasswordfun({payload}) {
  try {
    const response = yield call(updateAuthUserPassword,payload)
    yield put(updateAuthUserSuccess(response))

  } catch (error) {
    console.log("updateAuthUser error:", error); // Debugging line
    yield put(updateAuthUserFail(error))
  }
}


function* authSaga() {
  yield takeEvery(LOGIN_USER, loginUser)
  // yield takeEvery(UPDATE_AUTH_USER, updateAuthUser)
  yield takeLatest(SOCIAL_LOGIN, socialLogin)
  yield takeEvery(LOGOUT_USER, logoutUser)
  yield takeEvery(GET_AUTH_USER, fetchAuthUsers)
  yield takeEvery(GET_AUTH_CUSTOMER, fetchAuthCustomer)
  yield takeEvery(UPDATE_AUTH_USER,updateAuthUserfun)
  yield takeEvery(UPDATE_PASSWORD_REQUEST,updateAuthUserPasswordfun)
  

}

export default authSaga
